import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { openAI } from "@/components/ai/stream";
import { useAccess } from "@/lib/access";
import { ViewModeSwitch } from "@/lib/viewMode";
import { openOwner } from "./OwnerPin";
import { InstallButton } from "./InstallButton";
import { SECTIONS } from "./nav";

export const MoreSheet = () => {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { owner } = useAccess();
  useEffect(() => { const h = () => setOpen(true); window.addEventListener("more-open", h); return () => window.removeEventListener("more-open", h); }, []);
  const go = (to) => { setOpen(false); if (to === "ai") setTimeout(() => openAI({}), 250); else nav(to); };
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="bottom" className="bg-[var(--bg)] border-[var(--line)] rounded-t-3xl max-h-[88vh] overflow-y-auto pb-[calc(env(safe-area-inset-bottom)+1.5rem)]" data-testid="more-sheet">
        <div className="mx-auto w-10 h-1 rounded-full bg-slate-700 -mt-2 mb-3" />
        <SheetHeader className="text-left"><SheetTitle className="font-head text-2xl uppercase text-slate-100">Everything</SheetTitle>
          <SheetDescription className="text-xs">Every part of BTC Odds Watch, one tap away.</SheetDescription></SheetHeader>
        <div className="mt-4 space-y-5">
          {SECTIONS.map(([title, items]) => (
            <div key={title}><div className="text-[10px] uppercase tracking-[.18em] text-slate-600 font-bold mb-2">{title}</div>
              <div className="grid grid-cols-2 gap-2">
                {items.map(([to, l, I, id]) => (
                  <button key={id} onClick={() => go(to)} className="flex items-center gap-2.5 rounded-xl border border-[var(--line)] bg-[var(--card)] px-3 py-3 text-sm font-semibold text-left active:scale-[.98] transition-transform" data-testid={`more-${id}`}>
                    <I className={`w-4 h-4 shrink-0 ${to === "ai" ? "text-[var(--violet)]" : "text-[var(--cyan)]"}`} /><span className="truncate">{l}</span></button>))}
              </div></div>))}
          <button onClick={() => { setOpen(false); setTimeout(openOwner, 250); }} className="w-full flex items-center justify-between rounded-xl border border-[var(--gold)]/40 bg-[var(--gold)]/10 px-4 py-3.5 text-sm font-bold text-[var(--gold)]" data-testid="more-owner">
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" />{owner ? "Owner console" : "Owner login (PIN)"}</span><ChevronRight className="w-4 h-4" /></button>
          <div><div className="text-[10px] uppercase tracking-[.18em] text-slate-600 font-bold mb-2">Layout</div><ViewModeSwitch /></div>
          <InstallButton />
        </div>
      </SheetContent>
    </Sheet>
  );
};
